import omitBy from 'lodash/omitBy';
import isUndefined from 'lodash/isUndefined';
export const normaliseSearchParams = searchParams => {
  const filteredSearchParams = { ...searchParams,
    // Remove pagination params
    from: undefined,
    size: undefined
  };
  const params = Object.keys(filteredSearchParams).reduce((params, key) => {
    let value;

    if (key === 'filters') {
      var _searchParams$filters;

      value = ((_searchParams$filters = searchParams.filters) === null || _searchParams$filters === void 0 ? void 0 : _searchParams$filters.split(',').sort().join(',')) || '';
    } else {
      const originalSearchParam = filteredSearchParams[key];
      value = (originalSearchParam === null || originalSearchParam === void 0 ? void 0 : originalSearchParam.toString()) || '';
    }

    if (value) params[key] = value;
    return params;
  }, {});
  const query = new URLSearchParams(params);
  query.sort();
  return query.toString();
};
export const normaliseSearchUrl = searchParams => {
  var _urlSearch$sort;

  const urlSearch = new URLSearchParams(omitBy(searchParams, isUndefined));
  (_urlSearch$sort = urlSearch.sort) === null || _urlSearch$sort === void 0 ? void 0 : _urlSearch$sort.call(urlSearch);
  return urlSearch.toString();
};